var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleLinesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.3766,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    fill: "#DDDDDD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7766,
    y: 133.562,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    fill: "#DDDDDD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 141.781,
    y: 70.3767,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(90 141.781 70.3767)",
    fill: "#DDDDDD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.21918,
    y: 70.3767,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(90 8.21918 70.3767)",
    fill: "#DDDDDD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 121.381,
    y: 120.654,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(135 121.381 120.654)",
    fill: "#DDDDDD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9384,
    y: 26.2119,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(135 26.9384 26.2119)",
    fill: "#DDDDDD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1267,
    y: 121.381,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(-135 21.1267 121.381)",
    fill: "#DDDDDD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 115.569,
    y: 26.9386,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(-135 115.569 26.9386)",
    fill: "#DDDDDD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.23691,
    y: 97.6358,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(-111.749 5.23691 97.6358)",
    fill: "#DDDDDD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 129.291,
    y: 48.1449,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(-111.749 129.291 48.1449)",
    fill: "#DDDDDD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 4.90192,
    y: 44.9822,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(-68.1491 4.90192 44.9822)",
    fill: "#DDDDDD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 128.868,
    y: 94.6929,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(-68.1491 128.868 94.6929)",
    fill: "#DDDDDD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1832,
    y: 6.07082,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(-23.4724 42.1832 6.07082)",
    fill: "#DDDDDD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 95.3818,
    y: 128.58,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(-23.4724 95.3818 128.58)",
    fill: "#DDDDDD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5794,
    y: 5.21399,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(22.5303 97.5794 5.21399)",
    fill: "#DDDDDD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4023,
    y: 128.582,
    width: 1.0274,
    height: 8.21918,
    rx: 0.513699,
    transform: "rotate(22.5303 46.4023 128.582)",
    fill: "#DDDDDD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLinesIcon);
export default __webpack_public_path__ + "static/media/circleLines_icon.22a3cb2dbd94ebdb95a418026e6f6d73.svg";
export { ForwardRef as ReactComponent };